// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deal-taxes_graph__flH8u {
    text-align: center;
    /*padding: 0px 0 20px;*/
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 30px;
    min-height: 50%;
}

.deal-taxes_graphContainer__v9akN {
    width: 100%;
    /*padding-right: 4%;*/
    min-height: 50vh;
    position: relative;
}

.deal-taxes_graph__flH8u svg {
    /*max-width: 1650px;*/
    /*width: 100%;*/
    /*height: auto;*/
    /*margin: auto auto 0;*/
    /*!*max-height: calc(100vh - var(--header-height) - 140px);*!*/
    /*max-height: 74vh;*/

    max-width: 100%;
    width: 100%;
    height: auto;
    margin: auto auto 0;
    max-height: calc(100vh - var(--header-height) - 140px);
}

.deal-taxes_actions__H24yH {
    display: flex;
    justify-content: center;
    column-gap: 100px;
    row-gap: 6px;
    flex-wrap: wrap;
    max-width: 780px;
    max-width: 100%;
    margin: auto auto 10px;
}

.deal-taxes_tip__IcJX1 {
    border-top: 1px solid var(--primary-color);
    color: var(--primary-color);
    padding: 12px;
    width: 90%;
    margin-top: -52px;
}

.deal-taxes_expandBtn__2fD7a {
    position: absolute;
    top: 55%;
    left: -3%;
}

.deal-taxes_expandBtn__2fD7a button {
    font-size: 12px;
    height: 24px;
    min-height: 24px;
    line-height: 24px;
    min-width: 90px;
    padding: 0;
    border-radius: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DealTaxes/deal-taxes.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,8DAA8D;IAC9D,oBAAoB;;IAEpB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,aAAa;IACb,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,mBAAmB;AACvB","sourcesContent":[".graph {\n    text-align: center;\n    /*padding: 0px 0 20px;*/\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    row-gap: 30px;\n    min-height: 50%;\n}\n\n.graphContainer {\n    width: 100%;\n    /*padding-right: 4%;*/\n    min-height: 50vh;\n    position: relative;\n}\n\n.graph svg {\n    /*max-width: 1650px;*/\n    /*width: 100%;*/\n    /*height: auto;*/\n    /*margin: auto auto 0;*/\n    /*!*max-height: calc(100vh - var(--header-height) - 140px);*!*/\n    /*max-height: 74vh;*/\n\n    max-width: 100%;\n    width: 100%;\n    height: auto;\n    margin: auto auto 0;\n    max-height: calc(100vh - var(--header-height) - 140px);\n}\n\n.actions {\n    display: flex;\n    justify-content: center;\n    column-gap: 100px;\n    row-gap: 6px;\n    flex-wrap: wrap;\n    max-width: 780px;\n    max-width: 100%;\n    margin: auto auto 10px;\n}\n\n.tip {\n    border-top: 1px solid var(--primary-color);\n    color: var(--primary-color);\n    padding: 12px;\n    width: 90%;\n    margin-top: -52px;\n}\n\n.expandBtn {\n    position: absolute;\n    top: 55%;\n    left: -3%;\n}\n\n.expandBtn button {\n    font-size: 12px;\n    height: 24px;\n    min-height: 24px;\n    line-height: 24px;\n    min-width: 90px;\n    padding: 0;\n    border-radius: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"graph": `deal-taxes_graph__flH8u`,
	"graphContainer": `deal-taxes_graphContainer__v9akN`,
	"actions": `deal-taxes_actions__H24yH`,
	"tip": `deal-taxes_tip__IcJX1`,
	"expandBtn": `deal-taxes_expandBtn__2fD7a`
};
export default ___CSS_LOADER_EXPORT___;
